<template>
  <div class="user-table-container m-auto p-0">
    <div class="table-header px-3 py-1">
      <h3 class="text-light">Users</h3>
    </div>

    <div class="user-table-body mt-0">
      <div
        v-for="(u, index) in users"
        :key="index"
        :class="['user-row', index % 2 === 0 ? 'bg-light-row' : 'bg-dark-row']"
      >
        <div class="left d-flex align-items-center pl-2">
          <div class="avatar-box position-relative">
            <b-avatar :src="u.avatar" size="32" />
            <span
              class="status-dot"
              :class="{
                'bg-success': u.status === 'online',
                'bg-danger': u.status === 'offline',
              }"
            ></span>
          </div>
          <span class="ml-2 text-white-50">{{ u.name }}</span>
        </div>

        <div class="actions d-flex align-items-center">
          <feather-icon
            icon="Trash2Icon"
            size="20"
            class="text-white-50 mr-2 cursor-pointer"
          />
          <feather-icon
            icon="ChevronRightIcon"
            size="20"
            class="text-white-50 cursor-pointer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";

export default {
  components: { BAvatar },
  data() {
    return {
      users: Array.from({ length: 15 }, () => ({
        name: "Name Surname",
        status: Math.random() > 0.5 ? "online" : "offline",
        avatar: "",
      })),
    };
  },
};
</script>

<style scoped lang="scss">
.user-table-container {
  max-width: 90%;
  border-radius: 14px;
  overflow: hidden;
  backdrop-filter: blur(18px);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.table-header {
  background-color: rgba(35, 34, 34, 0.15);
  color: #fff;
  font-size: 0.95rem;
}

.user-table-body {
  max-height: 500px;
  overflow-y: auto;
}

.user-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  transition: background 0.3s;
}

.bg-light-row {
  background-color: rgba(255, 255, 255, 0.07);
}

.bg-dark-row {
  background-color: rgba(255, 255, 255, 0.03);
}

.avatar-box {
  position: relative;
}

.status-dot {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #1f1f1f;
}

.left {
  display: flex;
  align-items: center;
}
</style>
